import { put, call, getContext, select, cancel, delay, all } from 'redux-saga/effects';
import { IHttpApi } from '@cian/http-api/shared';
import { ILogger } from '@cian/logger';
import { getBetPosition, TGetBetPositionResult } from '../../../../services/auction/getBetPosition';
import { loadBetPositionFail, loadBetPositionStart, loadBetPositionSuccess } from '../../../reducers/betPosition';
import { getBetPositionParams } from './utils';
import { IAppState } from '../../../types';
import {
  selectServiceIds,
  selectIsNewPublishTermsEnabled,
  selectPackages,
  selectIsPromotionPackageSelected,
  selectActivePlacingType,
} from '../../../../selectors/publishTerms';
import { selectBetPositionClientError } from '../../../../selectors/betPosition';
import {
  selectDynamicPricingParameters,
  selectGeoChildLocation,
  selectOfferCoordinatesWithFallback,
} from '../../../../selectors/offer';
import { selectCurrentBet, selectIsAuctionEnabled } from '../../../../selectors/auction';
import { selectConfigValue } from '../../../../selectors/config';

export function* loadBetPosition() {
  const httpApi: IHttpApi = yield getContext('httpApi');
  const logger: ILogger = yield getContext('logger');

  const state: IAppState = yield select();

  const serviceIds = selectServiceIds(state);
  const isFeatureEnabled = selectIsNewPublishTermsEnabled(state);
  const clientError = selectBetPositionClientError(state);
  const childLocation = selectGeoChildLocation(state);
  const coordinates = selectOfferCoordinatesWithFallback(state);
  const packages = selectPackages(state);
  const currentBet = selectCurrentBet(state);
  const isAuctionEnabled = selectIsAuctionEnabled(state);
  const isPromotionPackageSelected = selectIsPromotionPackageSelected(state);
  const extraData = selectDynamicPricingParameters(state);
  const activePlacingType = selectActivePlacingType(state);
  /**
   * @todo Удалить строку с RS
   * @description Данный функционал появился в задаче CD-166174, будет удалён в задаче CD-166304
   */
  const diffPricesPackageEnabled = selectConfigValue('diffPricesPackageEnabled', state);

  const { offer } = state;

  if (!isFeatureEnabled || clientError) {
    yield cancel();
  }

  const parameters = getBetPositionParams({
    packages,
    offer,
    serviceIds,
    childLocation,
    coordinates,
    currentBet,
    isAuctionEnabled,
    isPromotionPackageSelected,
    extraData,
    activePlacingType,
    /**
     * @todo Удалить строку с RS
     * @description Данный функционал появился в задаче CD-166174, будет удалён в задаче CD-166304
     */
    diffPricesPackageEnabled,
  });

  yield put(loadBetPositionStart());

  const [response]: [TGetBetPositionResult] = yield all([
    call(getBetPosition, {
      httpApi,
      logger,
      parameters,
    }),
    // При быстром ответе сервера лоадер появляется на долю секунд в компоненте позиции, из-за чего происходит мерцание.
    // Для хорошего UX ограничиваем минимально возможное выполнение запроса
    delay(1000),
  ]);

  if (response.success) {
    yield put(loadBetPositionSuccess(response.payload));
  } else {
    yield put(loadBetPositionFail());
  }
}
